var pageTabs = (function() {
    var index = 0,
        tabs = $('.tabs-items li'),
        panes = $('.tab-pane');

    tabs.eq(index).addClass('active');
    tabs.eq(index+1).addClass('next');
    tabs.find('a').on('click', function (e) {
      console.log('pageTabs !', $(window).scrollTop())
      var id = parseInt($(this).attr('href').substr(4));
      tabs.removeClass('active prev next');
      tabs.eq(id).addClass('active');
      tabs.eq(id+1).addClass('next');
      tabs.eq(id-1).addClass('prev');
      panes.removeClass('active');
      panes.eq(id).addClass('active');

      Grid.init();

      e.preventDefault();
    });

  });
